export default __webpack_public_path__ + "static/media/man.bd25aa38.png";